"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * PluracoreCell - Cellule promotionnelle pour Pluracore
 * Affiche un bouton qui ouvre un modal présentant les solutions de l'entreprise
 */const PluracoreCell = ({
  styles_properties = {},
  scaleFactor = 1,
  ...rest
}) => {
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);

  // Styles personnalisables
  const primaryColor = styles_properties.primary_color || '#6366f1';
  const secondaryColor = styles_properties.secondary_color || '#8b5cf6';
  const backgroundColor = styles_properties.background_color || 'transparent';
  const textColor = styles_properties.text_color || '#ffffff';
  const buttonStyle = styles_properties.button_style || 'gradient'; // gradient, outline, minimal

  const solutions = [{
    icon: '🖥️',
    title: 'Bornes Interactives',
    description: 'Solutions d\'affichage dynamique et bornes tactiles pour accueillir et informer vos visiteurs.',
    features: ['Écrans tactiles', 'Affichage dynamique', 'Gestion centralisée']
  }, {
    icon: '📱',
    title: 'Applications Mobiles',
    description: 'Applications iOS et Android sur mesure pour connecter votre entreprise à vos clients.',
    features: ['iOS & Android', 'UX/UI Design', 'Notifications push']
  }, {
    icon: '🌐',
    title: 'Solutions Web',
    description: 'Sites web, applications métier et plateformes e-commerce performantes.',
    features: ['Sites vitrines', 'E-commerce', 'Applications métier']
  }, {
    icon: '🤖',
    title: 'Intelligence Artificielle',
    description: 'Intégration d\'IA pour automatiser et optimiser vos processus métiers.',
    features: ['Chatbots', 'Analyse de données', 'Automatisation']
  }, {
    icon: '☁️',
    title: 'Cloud & Infrastructure',
    description: 'Hébergement sécurisé et infrastructure scalable pour vos applications.',
    features: ['Hébergement cloud', 'Sécurité', 'Haute disponibilité']
  }, {
    icon: '🎨',
    title: 'Design & UX',
    description: 'Conception d\'interfaces utilisateur intuitives et esthétiques.',
    features: ['UI/UX Design', 'Prototypage', 'Tests utilisateurs']
  }];
  const keyframesStyle = `
        @keyframes pluracorePulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.02); }
        }
        @keyframes pluracoreGlow {
            0%, 100% { box-shadow: 0 0 20px ${primaryColor}40; }
            50% { box-shadow: 0 0 40px ${primaryColor}60; }
        }
        @keyframes pluracoreSlideUp {
            from { opacity: 0; transform: scale(0.95) translateY(20px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes pluracoreFadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        @keyframes pluracoreFloat {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
        }
        @keyframes pluracoreShine {
            0% { background-position: -200% center; }
            100% { background-position: 200% center; }
        }
    `;
  const getButtonStyles = () => {
    const baseStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: `${10 * scaleFactor}px`,
      padding: `${16 * scaleFactor}px ${32 * scaleFactor}px`,
      fontSize: `${16 * scaleFactor}px`,
      fontWeight: 600,
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      borderRadius: `${12 * scaleFactor}px`,
      cursor: 'pointer',
      transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
      position: 'relative',
      overflow: 'hidden'
    };
    switch (buttonStyle) {
      case 'outline':
        return {
          ...baseStyle,
          background: 'transparent',
          border: `2px solid ${primaryColor}`,
          color: primaryColor
        };
      case 'minimal':
        return {
          ...baseStyle,
          background: `${primaryColor}15`,
          border: 'none',
          color: primaryColor
        };
      case 'gradient':
      default:
        return {
          ...baseStyle,
          background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
          border: 'none',
          color: textColor,
          boxShadow: `0 4px 20px ${primaryColor}40`
        };
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: backgroundColor,
      padding: `${16 * scaleFactor}px`,
      boxSizing: 'border-box'
    },
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: keyframesStyle
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      onClick: () => setIsModalOpen(true),
      style: getButtonStyles(),
      onMouseEnter: e => {
        e.currentTarget.style.transform = 'translateY(-3px) scale(1.02)';
        if (buttonStyle === 'gradient') {
          e.currentTarget.style.boxShadow = `0 8px 30px ${primaryColor}50`;
        }
      },
      onMouseLeave: e => {
        e.currentTarget.style.transform = 'translateY(0) scale(1)';
        if (buttonStyle === 'gradient') {
          e.currentTarget.style.boxShadow = `0 4px 20px ${primaryColor}40`;
        }
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          fontSize: `${20 * scaleFactor}px`
        },
        children: "\u2728"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: "Propuls\xE9 par Pluracore"
      })]
    }), isModalOpen && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        onClick: () => setIsModalOpen(false),
        style: {
          position: 'fixed',
          inset: 0,
          background: 'rgba(0, 0, 0, 0.85)',
          backdropFilter: 'blur(10px)',
          zIndex: 9998,
          animation: 'pluracoreFadeIn 0.3s ease'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: `${20 * scaleFactor}px`,
          pointerEvents: 'none'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            width: '90%',
            maxWidth: `${900 * scaleFactor}px`,
            maxHeight: '90vh',
            background: 'linear-gradient(165deg, #1a1a2e 0%, #0f0f1a 100%)',
            borderRadius: `${24 * scaleFactor}px`,
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: `0 30px 80px rgba(0, 0, 0, 0.6), 0 0 100px ${primaryColor}20`,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            animation: 'pluracoreSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
            pointerEvents: 'auto'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              padding: `${32 * scaleFactor}px`,
              background: `linear-gradient(135deg, ${primaryColor}15 0%, ${secondaryColor}10 100%)`,
              borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
              position: 'relative'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setIsModalOpen(false),
              style: {
                position: 'absolute',
                top: `${20 * scaleFactor}px`,
                right: `${20 * scaleFactor}px`,
                width: `${40 * scaleFactor}px`,
                height: `${40 * scaleFactor}px`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: `${10 * scaleFactor}px`,
                color: '#94a3b8',
                fontSize: `${18 * scaleFactor}px`,
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              },
              onMouseEnter: e => {
                e.currentTarget.style.background = 'rgba(239, 68, 68, 0.2)';
                e.currentTarget.style.borderColor = 'rgba(239, 68, 68, 0.4)';
                e.currentTarget.style.color = '#ef4444';
              },
              onMouseLeave: e => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.color = '#94a3b8';
              },
              children: "\u2715"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                display: 'flex',
                alignItems: 'center',
                gap: `${16 * scaleFactor}px`,
                marginBottom: `${12 * scaleFactor}px`
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  width: `${60 * scaleFactor}px`,
                  height: `${60 * scaleFactor}px`,
                  background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                  borderRadius: `${14 * scaleFactor}px`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: `${28 * scaleFactor}px`,
                  boxShadow: `0 8px 30px ${primaryColor}40`,
                  animation: 'pluracoreFloat 3s ease-in-out infinite'
                },
                children: "\uD83D\uDE80"
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
                  style: {
                    margin: 0,
                    fontSize: `${32 * scaleFactor}px`,
                    fontWeight: 700,
                    fontFamily: "'Inter', sans-serif",
                    background: `linear-gradient(135deg, #ffffff 0%, ${primaryColor} 100%)`,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  },
                  children: "Pluracore"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  style: {
                    margin: 0,
                    fontSize: `${14 * scaleFactor}px`,
                    color: '#94a3b8',
                    letterSpacing: `${1 * scaleFactor}px`
                  },
                  children: "Solutions digitales innovantes"
                })]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              style: {
                margin: 0,
                fontSize: `${16 * scaleFactor}px`,
                color: '#e2e8f0',
                lineHeight: 1.6,
                maxWidth: `${600 * scaleFactor}px`
              },
              children: "Nous concevons et d\xE9veloppons des exp\xE9riences digitales sur mesure pour transformer votre vision en r\xE9alit\xE9."
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              padding: `${28 * scaleFactor}px`,
              overflowY: 'auto',
              flex: 1
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
              style: {
                margin: `0 0 ${20 * scaleFactor}px`,
                fontSize: `${13 * scaleFactor}px`,
                fontWeight: 600,
                color: primaryColor,
                textTransform: 'uppercase',
                letterSpacing: `${2 * scaleFactor}px`
              },
              children: "Nos Solutions"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: 'grid',
                gridTemplateColumns: `repeat(auto-fit, minmax(${250 * scaleFactor}px, 1fr))`,
                gap: `${16 * scaleFactor}px`
              },
              children: solutions.map((solution, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(SolutionCard, {
                solution: solution,
                index: index,
                scaleFactor: scaleFactor,
                primaryColor: primaryColor,
                secondaryColor: secondaryColor
              }, index))
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              padding: `${20 * scaleFactor}px ${28 * scaleFactor}px`,
              borderTop: '1px solid rgba(255, 255, 255, 0.08)',
              background: 'rgba(0, 0, 0, 0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: `${16 * scaleFactor}px`
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                display: 'flex',
                alignItems: 'center',
                gap: `${20 * scaleFactor}px`
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
                href: "https://pluracore.com",
                target: "_blank",
                rel: "noopener noreferrer",
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  gap: `${8 * scaleFactor}px`,
                  color: '#94a3b8',
                  fontSize: `${13 * scaleFactor}px`,
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                },
                onMouseEnter: e => e.currentTarget.style.color = primaryColor,
                onMouseLeave: e => e.currentTarget.style.color = '#94a3b8',
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  children: "\uD83C\uDF10"
                }), " pluracore.com"]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
                href: "mailto:contact@pluracore.com",
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  gap: `${8 * scaleFactor}px`,
                  color: '#94a3b8',
                  fontSize: `${13 * scaleFactor}px`,
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                },
                onMouseEnter: e => e.currentTarget.style.color = primaryColor,
                onMouseLeave: e => e.currentTarget.style.color = '#94a3b8',
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  children: "\uD83D\uDCE7"
                }), " contact@pluracore.com"]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
              onClick: () => window.open('https://pluracore.com/contact', '_blank'),
              style: {
                display: 'flex',
                alignItems: 'center',
                gap: `${8 * scaleFactor}px`,
                padding: `${12 * scaleFactor}px ${24 * scaleFactor}px`,
                background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                border: 'none',
                borderRadius: `${10 * scaleFactor}px`,
                color: 'white',
                fontSize: `${14 * scaleFactor}px`,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: `0 4px 15px ${primaryColor}40`
              },
              onMouseEnter: e => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = `0 6px 20px ${primaryColor}50`;
              },
              onMouseLeave: e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = `0 4px 15px ${primaryColor}40`;
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: "\uD83D\uDCAC"
              }), "Nous contacter"]
            })]
          })]
        })
      })]
    })]
  });
};

// Composant carte solution
const SolutionCard = ({
  solution,
  index,
  scaleFactor,
  primaryColor,
  secondaryColor
}) => {
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    style: {
      padding: `${20 * scaleFactor}px`,
      background: isHovered ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.03)',
      border: `1px solid ${isHovered ? primaryColor + '40' : 'rgba(255, 255, 255, 0.08)'}`,
      borderRadius: `${16 * scaleFactor}px`,
      cursor: 'pointer',
      transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
      transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
      boxShadow: isHovered ? `0 10px 30px rgba(0, 0, 0, 0.3)` : 'none',
      animation: `pluracoreSlideUp 0.4s ease ${index * 0.05}s both`
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: `${48 * scaleFactor}px`,
        height: `${48 * scaleFactor}px`,
        background: `linear-gradient(135deg, ${primaryColor}20 0%, ${secondaryColor}15 100%)`,
        borderRadius: `${12 * scaleFactor}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: `${24 * scaleFactor}px`,
        marginBottom: `${14 * scaleFactor}px`,
        transition: 'transform 0.3s ease',
        transform: isHovered ? 'scale(1.1)' : 'scale(1)'
      },
      children: solution.icon
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      style: {
        margin: `0 0 ${8 * scaleFactor}px`,
        fontSize: `${16 * scaleFactor}px`,
        fontWeight: 600,
        color: '#f1f5f9'
      },
      children: solution.title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      style: {
        margin: `0 0 ${12 * scaleFactor}px`,
        fontSize: `${13 * scaleFactor}px`,
        color: '#94a3b8',
        lineHeight: 1.5
      },
      children: solution.description
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: `${6 * scaleFactor}px`
      },
      children: solution.features.map((feature, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          padding: `${4 * scaleFactor}px ${10 * scaleFactor}px`,
          background: `${primaryColor}15`,
          borderRadius: `${6 * scaleFactor}px`,
          fontSize: `${11 * scaleFactor}px`,
          color: primaryColor,
          fontWeight: 500
        },
        children: feature
      }, i))
    })]
  });
};
var _default = exports.default = PluracoreCell;